import React from 'react';
import { Tooltip } from 'antd';
import { UserDeleteOutlined } from '@ant-design/icons';
import { EstadoOportunidad } from '../../api/oportunidadesApi';
import { etiquetaEstado } from './reglas';
import { FctEstado, type FctFamilia, type FctNombreIcono } from '../../fct/react';
import { fct } from '../../fct/tokens/tokens';

// Semáforo del manual de marca digital v0.9.1 con `FctEstado` (GCVSC-I001 R-11): color con icono
// y etiqueta siempre; sin color, la etiqueta dice lo mismo. Mapeo ya aplicado en OPOR-I001
// (`mapeo-estados.md` §A): Pendiente proceso · Descarte pendiente aviso · Descartada neutro ·
// Atendida éxito.
const ESTILO: Record<number, { familia: FctFamilia; icono: FctNombreIcono }> = {
  [EstadoOportunidad.Pendiente]: { familia: 'proceso', icono: 'hora' },
  [EstadoOportunidad.DescartePendiente]: { familia: 'aviso', icono: 'alerta' },
  [EstadoOportunidad.Descartada]: { familia: 'neutro', icono: 'cancelado' },
  [EstadoOportunidad.Atendida]: { familia: 'exito', icono: 'completado' },
};

export const EstadoOportunidadTag: React.FC<{ estado: number }> = ({ estado }) => {
  const e = ESTILO[estado] ?? { familia: 'neutro' as const, icono: 'hora' as const };
  return <FctEstado personalizado={{ etiqueta: etiquetaEstado(estado), ...e }} />;
};

/** Marca de «pendiente de asignar» (R-04, spec rev. 3): la oportunidad no tiene responsable. */
export const PendienteAsignarTag: React.FC = () => (
  <FctEstado personalizado={{ etiqueta: 'Pendiente de asignar', familia: 'aviso', icono: 'usuario' }} />
);

/**
 * Responsable de una oportunidad (R-04, CA-23). Sin responsable: solo la marca de pendiente de
 * asignar. Viva con el responsable de baja: el nombre en rojo de riesgo, con icono y tooltip.
 */
export const ResponsableOportunidad: React.FC<{
  responsable?: string;
  pendienteAsignar: boolean;
  responsableBaja: boolean;
}> = ({ responsable, pendienteAsignar, responsableBaja }) => {
  if (pendienteAsignar) return <PendienteAsignarTag />;
  const nombre = responsable || '—'; // responsable sin nombre en su ficha: no es «pendiente de asignar»
  if (!responsableBaja) return <span>{nombre}</span>;
  return (
    <Tooltip title="Responsable de baja">
      <span style={{ color: fct.estado.riesgo.texto, display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <UserDeleteOutlined aria-label="Responsable de baja" />
        {nombre}
      </span>
    </Tooltip>
  );
};
